import dotProp from 'dot-prop-immutable';

import { SET_AB_TEST_CONFIG } from '../actions/types';

const abTesting = (state = {}, action) => {
  switch (action.type) {
    case SET_AB_TEST_CONFIG:
      return dotProp.set(state, action.featureName, action.value);
    default:
      return state;
  }
};

export default abTesting;
